import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { SnowflakeIcon, FlameIcon, BrainIcon } from './Icons';
export function StorySection() {
  const hook = useScrollReveal();
  const pain = useScrollReveal();
  const reveal = useScrollReveal();
  return <section className="py-20 bg-cream-light" data-id="element-183">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        {/* Section 1: The Hook */}
        <div ref={hook.ref} className={`mb-20 text-center reveal ${hook.isVisible ? 'visible' : ''}`} data-id="element-185">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm text-sage" data-id="element-186">
            <SnowflakeIcon className="w-8 h-8" data-id="element-187" />
          </div>
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-charcoal mb-6" data-id="element-188">
            El Gancho: ¿Por qué ya nada funciona?
          </h2>
          <p className="text-lg text-charcoal-light font-sans leading-relaxed" data-id="element-189">
            ¿Te ha pasado que, de repente, la dieta que siempre te funcionó dejó
            de hacer efecto? ¿Te miras al espejo y sientes una hinchazón que no
            se va, aunque comas solo ensaladas? No es falta de voluntad. No es
            que estés "envejeciendo" sin remedio.{' '}
            <strong className="text-charcoal font-semibold" data-id="element-190">
              Es que tu cuerpo ha activado el Interruptor de Grasa por
              Supervivencia.
            </strong>
          </p>
        </div>

        {/* Section 2: Pain Agitation */}
        <div ref={pain.ref} className={`mb-20 bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-cream reveal ${pain.isVisible ? 'visible' : ''}`} data-id="element-191">
          <div className="flex items-center gap-4 mb-6" data-id="element-192">
            <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center text-[#B85C5C]" data-id="element-193">
              <FlameIcon className="w-6 h-6" data-id="element-194" />
            </div>
            <h3 className="text-2xl font-playfair font-bold text-charcoal" data-id="element-195">
              La Agitación del Dolor
            </h3>
          </div>

          <div className="space-y-6 text-lg text-charcoal-light font-sans leading-relaxed" data-id="element-196">
            <p data-id="element-197">
              Has intentado todo. Cortaste los carbohidratos, te inscribiste al
              gimnasio, cuentas cada gramo en una app que odias... y aun así, la
              balanza no se mueve. O peor: sube.
            </p>
            <p data-id="element-198">
              Te despiertas a las 3 de la mañana con la mente a mil y el corazón
              inquieto. Te sientes agotada durante el día, pero "eléctrica" por
              la noche. Tienes antojos incontrolables de dulce a las 5 de la
              tarde que arruinan todo tu esfuerzo.{' '}
              <strong className="text-[#B85C5C] font-semibold" data-id="element-199">
                Sientes que tu cuerpo te está traicionando.
              </strong>
            </p>
            <div className="pl-6 border-l-4 border-sage/30 italic text-charcoal" data-id="element-200">
              Lo que nadie te ha dicho es que, después de los 35, las reglas
              cambian. Tu cuerpo no está quemando energía; la está almacenando
              para protegerse de lo que él percibe como un estado de emergencia
              constante:{' '}
              <strong className="font-semibold" data-id="element-201">
                el cortisol alto y el desequilibrio de la perimenopausia.
              </strong>
            </div>
          </div>
        </div>

        {/* Section 3: The Revelation */}
        <div ref={reveal.ref} className={`text-center reveal ${reveal.isVisible ? 'visible' : ''}`} data-id="element-202">
          <div className="w-16 h-16 bg-sage text-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-md" data-id="element-203">
            <BrainIcon className="w-8 h-8" data-id="element-204" />
          </div>
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-charcoal mb-6" data-id="element-205">
            La Revelación: El Efecto Reseteo Hormonal H2
          </h2>
          <p className="text-lg text-charcoal-light font-sans leading-relaxed mb-6" data-id="element-206">
            La solución no es comer menos. La solución es{' '}
            <strong className="text-sage-dark font-semibold" data-id="element-207">
              señalizar seguridad a tu sistema nervioso.
            </strong>
          </p>
          <p className="text-lg text-charcoal-light font-sans leading-relaxed" data-id="element-208">
            Cuando aprendes a bajar el cortisol en 60 segundos y a alimentar tus
            hormonas en lugar de tus miedos, ocurre algo mágico: el cuerpo
            suelta la grasa. Deja de retener líquidos. La "niebla mental"
            desaparece. Este es el{' '}
            <strong className="text-charcoal font-semibold" data-id="element-209">
              Efecto Reseteo Hormonal H2
            </strong>
            : la transición biológica de sobrevivir a florecer.
          </p>
        </div>
      </div>
    </section>;
}